import { type MutationHookOptions, useMutation } from "@apollo/client";
import { CreateRestreamDestinationMutation } from "../graphql/mutations";
import type {
  CreateRestreamDestinationMutationType,
  CreateRestreamDestinationMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useCreateRestreamDestinationMutation = (
  options?: MutationHookOptions<
    CreateRestreamDestinationMutationType,
    CreateRestreamDestinationMutationVariablesType
  >
) => {
  return useMutation<
    CreateRestreamDestinationMutationType,
    CreateRestreamDestinationMutationVariablesType
  >(CreateRestreamDestinationMutation, options);
};
